@if (universalService.showSuccessToastMessage) {
  <div
    class="toast-main animated bounceInDown toast-main-addto-jiocloud">
    <div class="toast-msg">
      <h2>
        <span class="NeueFileFilledSelected"></span>
        <span class="msgCont">{{universalService.toastMessage}} </span>
      </h2>
    </div>
  </div>
}
@if (universalService.showErrorToastMessage) {
  <div class="toast-main animated bounceInDown">
    <div class="toast-msg">
      <h2>
        <span class="NeueDFilledError"></span>
        <span class="msgCont">{{universalService.toastMessage}}</span>
      </h2>
    </div>
  </div>
}
@if (universalService.showWarningToastMessage) {
  <div class="toast-main animated bounceInDown">
    <div class="toast-msg">
      <h2>
        <span class="NeueDFilledError"></span>
        <span class="msgCont">{{universalService.toastMessage}}</span>
      </h2>
    </div>
  </div>
}
<main role="main">
  <div id="jcAbout">
    
    @defer{
      <lib-landing-header (TR)="topReached($event)"/>
    }
    
    <section id="home-screen" >
      <div class="home-inner" [ngClass]="!universalService.isSupprtedBrowser || universalService.showDownTimeBanner ? 'add-margin-top':''">
        <common-landing-slider />
        
        <div class="fix-width">
          @if(!universalService.isMobileDevice){
            <section id="user-login">
                <h2 class="section-title-medium text-center">
                  @if(landingService.landingPageData?.login?.bigTitle){
                    {{landingService.landingPageData?.login?.bigTitle}}
                  }@else{
                    Sign in to JioAICloud
                  }
                </h2>
                <div class="user-login-block">
                  <div class="area-code">+91</div>
                  <input #jionumber type="text" placeholder="Mobile Number" maxlength="10" (keyup)="loginNoValidation(jionumber)" id="jioPhoneNumber" autocomplete="off"/>
                  <button (click)="openLogin(jionumber)">
                    @if(landingService.landingPageData?.signin){
                    {{landingService.landingPageData?.signin}}
                    }@else{
                      Sign in
                    }
                  </button>
                </div>
            </section>
          }

          <section id="main-features">
              <h1 class="section-title-large text-center">
                @if(landingService.landingPageData?.mainFeaturesSection?.bigTitle){
                  {{landingService.landingPageData?.mainFeaturesSection?.bigTitle}}
                }@else{
                  Experience JioAICloud - Intelligent Cloud Storage
                }
              </h1>
              <div class="text-center main-feature-cont">
                <div class="p-6 main-feature-details">
                  @defer{
                    <img loading="lazy" src="https://static.jiocloud.com/web2.0/landing/Images/Icon1.webp" alt="Free Storage">
                  }
                  <h3>
                    @if(landingService.landingPageData?.mainFeaturesSection?.txt1){
                      {{landingService.landingPageData?.mainFeaturesSection?.txt1}}<br/> {{landingService.landingPageData?.mainFeaturesSection?.txt2}}
                    }@else{
                      Free <br/>Storage
                    }
                  </h3>
                </div>
                <div class="main-feature-details">
                  @defer{
                    <img loading="lazy" src="https://static.jiocloud.com/web2.0/landing/Images/Icon2.webp" alt="AI Tools">
                  }
                  <h3>
                    @if(landingService.landingPageData?.mainFeaturesSection?.txt3){
                      {{landingService.landingPageData?.mainFeaturesSection?.txt3}}<br/>{{landingService.landingPageData?.mainFeaturesSection?.txt4}}
                    }@else{
                      Latest<br/>AI Tools
                    }
                  </h3>
                </div>
                <div class="main-feature-details">
                  @defer{
                    <img loading="lazy" src="https://static.jiocloud.com/web2.0/landing/Images/Icon3.webp" alt="DigiLocker">
                  }
                  <h3>
                    @if(landingService.landingPageData?.mainFeaturesSection?.txt5){
                      {{landingService.landingPageData?.mainFeaturesSection?.txt5}}<br/>{{landingService.landingPageData?.mainFeaturesSection?.txt6}}
                    }@else{
                      Inbuilt<br/>DigiLocker
                    }
                  </h3>
                </div>
              </div>
          </section>
          
          <section id="storage-features">
            <!-- <h2 class="section-title-large text-center">
              @if(landingService.landingPageData?.storageFeaturesSection?.bigTitle){
                {{landingService.landingPageData?.storageFeaturesSection?.bigTitle}}
              }@else{
                Store More with
              }
            </h2>
            <p class="section-sub-title text-center">
              @if(landingService.landingPageData?.storageFeaturesSection?.titleSubTxt){
                {{landingService.landingPageData?.storageFeaturesSection?.titleSubTxt}}
              }@else{
                Free  Storage
              }
            </p> -->
            <div class="text-center storage-feature-cont">
              <div class="storage-feature-details">
                @defer{
                  <img loading="lazy" src="https://static.jiocloud.com/web2.0/landing/Images/storage-card2-1.webp" alt="AI Tools">
                }
                <div class="storage-feature-details-txt">
                  <h2>
                    @if(landingService.landingPageData?.storageFeaturesSection?.mainTxt1){
                      {{landingService.landingPageData?.storageFeaturesSection?.mainTxt1}}
                    }@else{
                      Store Intelligently
                    }
                  </h2>
                  <p class="mb-0">
                    @if(landingService.landingPageData?.storageFeaturesSection?.subText1){
                      {{landingService.landingPageData?.storageFeaturesSection?.subText1}}
                    }@else{
                      Free secure storage - for all that matters.
                    }
                  </p>
                </div>
              </div>
              <div class="storage-feature-details">
                @defer{
                  <img loading="lazy" src="https://static.jiocloud.com/web2.0/landing/Images/storage-card1-2.webp" alt="AI Tools">
                }
                <div class="storage-feature-details-txt">
                  <h2>
                    @if(landingService.landingPageData?.storageFeaturesSection?.mainTxt2){
                      {{landingService.landingPageData?.storageFeaturesSection?.mainTxt2}}
                    }@else{
                      Share Intelligently
                    }
                  </h2>
                  <p class="mb-0">
                    @if(landingService.landingPageData?.storageFeaturesSection?.subText2){
                      {{landingService.landingPageData?.storageFeaturesSection?.subText2}}
                    }@else{
                      Instantly auto-share photos with your loved ones.
                    }
                  </p>
                </div>
              </div>
              <div class="storage-feature-details storage-full-width">
                @defer{
                  @if(universalService.isMobileDevice){
                  <img loading="lazy" src="https://static.jiocloud.com/web2.0/landing/Images/storage-card4.webp" alt="AI Tools">
                  }@else{
                    <img loading="lazy" src="https://static.jiocloud.com/web2.0/landing/Images/storage-card3-1.webp" alt="AI Tools">
                  }
                }
                <div class="storage-feature-details-txt">
                  <h2>
                    @if(landingService.landingPageData?.storageFeaturesSection?.mainTxt3){
                      {{landingService.landingPageData?.storageFeaturesSection?.mainTxt3}}
                    }@else{
                      Create Intelligently
                    }
                  </h2>
                  <p class="mb-0">
                    @if(universalService.isMobileDevice){
                      @if(landingService.landingPageData?.storageFeaturesSection?.subText3){
                        {{landingService.landingPageData?.storageFeaturesSection?.subText3}} {{landingService.landingPageData?.storageFeaturesSection?.subText4}}
                      }@else{
                        Transform your selfies into stunning AI-powered creations.
                      }
                    }@else{
                      @if(landingService.landingPageData?.storageFeaturesSection?.subText3){
                        {{landingService.landingPageData?.storageFeaturesSection?.subText3}} {{landingService.landingPageData?.storageFeaturesSection?.subText4}}
                      }@else{
                        Transform your selfies into stunning AI-powered <br/>creations.
                      }
                    }
                    
                  </p>
                </div>
              </div>
              
            </div>
          </section>

          <section id="more-features">
            <h2 class="section-title-large text-center">
              @if(landingService.landingPageData?.moreFeaturesSection?.bigTitle){
                {{landingService.landingPageData?.moreFeaturesSection?.bigTitle}}
              }@else{
                Live Intelligently
              }
            </h2>
            <p class="section-sub-title text-center">
              @if(landingService.landingPageData?.moreFeaturesSection?.titleSubTxt){
                {{landingService.landingPageData?.moreFeaturesSection?.titleSubTxt}}
              }@else{
                With JioAICloud
              }
            </p>

            <div class="more-feature-wrapper">
              <div class="text-center more-feature-cont" id="more-feature-memories">
                <div class="feature-graphic-cont grid-order2">
                  @defer{
                    <!-- <img src="/assets/images/video.mov" class="imgGraphic" height="" width=""> -->
                    <video autoplay="" loop="" muted="" playsinline="" ><source _ngcontent-ng-c1893886130="" src="https://static.jiocloud.com/web2.0/landing/Images/jiocloud-memory-3.mp4" type="video/mp4"></video>
                  }
                </div>
                <div  class="feature-details">
                  <p class="feature-details-title">
                    @if(landingService.landingPageData?.moreFeaturesSection?.heading1){
                      {{landingService.landingPageData?.moreFeaturesSection?.heading1}}
                    }@else{
                      AI Memories
                    }
                  </p>
                  <h3>
                    @if(landingService.landingPageData?.moreFeaturesSection?.mainTxt1){
                      {{landingService.landingPageData?.moreFeaturesSection?.mainTxt1}}
                    }@else{
                      Relive moments, share stories
                    }
                  </h3>
                  <p class="feature-details-desc">
                    @if(landingService.landingPageData?.moreFeaturesSection?.subText1){
                      {{landingService.landingPageData?.moreFeaturesSection?.subText1}}
                    }@else{
                      Let AI organise your precious photos into beautiful collections that bring your memories to life
                    }
                  ​</p>
                </div>
              </div>
              <span style="padding: 32px 0;display: block;"></span>
              <div class="text-center more-feature-cont" id="more-feature-people">
                <div  class="feature-details">
                  <p class="feature-details-title">
                    @if(landingService.landingPageData?.moreFeaturesSection?.heading2){
                      {{landingService.landingPageData?.moreFeaturesSection?.heading2}}
                    }@else{
                      EasyShare                  }
                  </p>
                  <h3>
                    @if(landingService.landingPageData?.moreFeaturesSection?.mainTxt2){
                      {{landingService.landingPageData?.moreFeaturesSection?.mainTxt2}}
                    }@else{
                      Instant, always-on sharing
                    }
                  </h3>
                  <p class="feature-details-desc">
                    @if(landingService.landingPageData?.moreFeaturesSection?.subText2){
                      {{landingService.landingPageData?.moreFeaturesSection?.subText2}}
                    }@else{
                      AI groups your photos for easy sharing. Pick who to share with once and they'll receive latest photos automatically.
                    }
                </div>
                <div class="feature-graphic-cont">
                  @defer{
                    <video autoplay="" loop="" muted="" playsinline="" ><source src="https://static.jiocloud.com/web2.0/landing/Images/easy-share-1.mp4" type="video/mp4"></video>
                    <!-- <img loading="lazy" src="https://static.jiocloud.com/web2.0/landing/Images/more-feature-card2.webp" class="imgGraphic fullSizeDevice" height="" width=""> -->
                  }
                </div>
              </div>
              <span style="padding: 32px 0;display: block;"></span>
              <div class="text-center more-feature-cont" id="more-feature-search">
                <div class="feature-graphic-cont grid-order2">
                  @defer{
                    <img loading="lazy" src="https://static.jiocloud.com/web2.0/landing/Images/more-feature-card3.webp" class="imgGraphic" height="" width="">
                  }
                </div>
                <div  class="feature-details">
                  <p class="feature-details-title">
                    @if(landingService.landingPageData?.moreFeaturesSection?.heading3){
                      {{landingService.landingPageData?.moreFeaturesSection?.heading3}}
                    }@else{
                      AI Search              
                    }
                  </p>
                  <h3>
                    @if(landingService.landingPageData?.moreFeaturesSection?.mainTxt3){
                      {{landingService.landingPageData?.moreFeaturesSection?.mainTxt3}}
                    }@else{
                      Find photos by what's in them
                    }
                  </h3>
                  <p class="feature-details-desc">
                    @if(landingService.landingPageData?.moreFeaturesSection?.subText3){
                      {{landingService.landingPageData?.moreFeaturesSection?.subText3}}
                    }@else{
                      Type what you remember about the photo - like 'beach sunset' or 'birthday party' and find it right away.
                    }
                  ​</p>
                  <!-- <h3>AI Search</h3>
                  <p class="feature-details-desc">Find photos by what's in them.</p>
                  <p class="feature-details-desc mt-1">Type what you remember about the photo - like "birthday party" - and find it right away​</p> -->
                </div>
              </div>
              <span style="padding: 32px 0;display: block;"></span>
              <div class="text-center more-feature-cont" id="more-feature-ai-magic">
                <div  class="feature-details">
                  <p class="feature-details-title">
                    @if(landingService.landingPageData?.moreFeaturesSection?.heading4){
                      {{landingService.landingPageData?.moreFeaturesSection?.heading4}}
                    }@else{
                      AI Photo Play             
                    }
                  </p>
                  <h3>
                    @if(landingService.landingPageData?.moreFeaturesSection?.mainTxt4){
                      {{landingService.landingPageData?.moreFeaturesSection?.mainTxt4}}
                    }@else{
                      One selfie, many looks
                    }
                  </h3>
                  <p class="feature-details-desc">
                    @if(landingService.landingPageData?.moreFeaturesSection?.subText4){
                      {{landingService.landingPageData?.moreFeaturesSection?.subText4}}
                    }@else{
                      Transform your selfies with AI powered themes and vibes. Switch between sporty, fun, classic and corporate vibes.
                    }
                  ​</p>
                </div>
                <div class="feature-graphic-cont">
                  <!-- <img src="https://static.jiocloud.com/web2.0/landing/Images/more-feature-card4.webp" > -->
  
                  <section class="image-comparison" data-component="image-comparison-slider" >
                    <div class="comparison-container" #container (click)="moveSliderOnClick($event)">
                      <figure>
                        <img src="https://static.jiocloud.com/web2.0/landing/Images/ai_magic2.webp" alt="">
                        <figcaption #captionBefore class="caption-before"><span class="image-caption-body">Original</span></figcaption>
                      </figure>
                      <figure>
                        <img id="compare" #compare src="https://static.jiocloud.com/web2.0/landing/Images/ai_magic1.webp" alt="">
                        <figcaption #captionAfter class="caption-after"><span class="image-caption-body">Photo Play</span></figcaption>
                      </figure>
                    
                      <input type="range" min="0" max="100" value="50" id="slider" #slider (input)="slide($event)">
                    
                      <div class="divider-line" #divider></div>
                    
                      <span class="image-comparison__thumb" #thumb (mousedown)="startDragging($event)" (touchstart)="startDragging($event)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="currentColor">
                          <path d="M12.121 4.703V.488c0-.302.384-.454.609-.24l4.42 4.214a.33.33 0 0 1 0 .481l-4.42 4.214c-.225.215-.609.063-.609-.24V4.703z"></path>
                          <path d="M5.879 4.703V.488c0-.302-.384-.454-.609-.24L.85 4.462a.33.33 0 0 0 0 .481l4.42 4.214c.225.215.609.063.609-.24V4.703z"></path>
                        </svg>
                      </span>
                    </div>
                    
                  </section>
  
                </div>
              </div>
              <span style="padding: 32px 0;display: block;"></span>
              <div class="text-center more-feature-cont" id="more-feature-scanner">
                <div class="feature-graphic-cont grid-order2">
                  @defer{
                  <img loading="lazy" src="https://static.jiocloud.com/web2.0/landing/Images/more-feature-card4.webp" height="" width="">
                  }
                </div>
                <div class="feature-details">
                  <p class="feature-details-title">
                    @if(landingService.landingPageData?.moreFeaturesSection?.heading5){
                      {{landingService.landingPageData?.moreFeaturesSection?.heading5}}
                    }@else{
                      AI Scanner    
                    }
                  </p>
                  <h3>
                    @if(landingService.landingPageData?.moreFeaturesSection?.mainTxt5){
                      {{landingService.landingPageData?.moreFeaturesSection?.mainTxt5}}
                    }@else{
                      Turn papers into searchable files
                    }
                  </h3>
                  <p class="feature-details-desc">
                    @if(landingService.landingPageData?.moreFeaturesSection?.subText5){
                      {{landingService.landingPageData?.moreFeaturesSection?.subText5}}
                    }@else{
                      Snap a photo of any document or note and instantly get clear, searchable digital copies.
                    }
                  ​</p>
                </div>
              </div>
            </div>
          </section>
          @defer{
            <section id="digilocker">
              <div class="text-center digilocker-cont">
                @if(!universalService.isMobileDevice){
                  <img src="https://static.jiocloud.com/web2.0/landing/Images/digilocker-card.webp"/>
                }@else{
                  <img src="https://static.jiocloud.com/web2.0/landing/Images/digilocker-card-mobile.webp"/>
                }
                <div class="digilocker-details">
                  <p class="digilocker-details-title highLightedTxt">
                    @if(landingService.landingPageData?.digilockerSection.heading1 && landingService.landingPageData?.digilockerSection.heading2){
                      {{landingService.landingPageData?.digilockerSection.heading1}} {{landingService.landingPageData?.digilockerSection.highLightedTxt}} {{landingService.landingPageData?.digilockerSection.heading2}}
                    }@else{
                      Inbuilt DigiLocker Access
                    }
                  </p>
                  <h2>
                    @if(landingService.landingPageData?.digilockerSection.mainTxt1 && landingService.landingPageData?.digilockerSection.mainTxt2){
                      {{landingService.landingPageData?.digilockerSection.mainTxt1}}<br/> 
                      {{landingService.landingPageData?.digilockerSection.mainTxt2}}
                    }@else{
                      Carry verified documents, digitally
                    }
                  </h2>
                  @if(universalService.isMobileDevice){
                    <p>
                      @if(landingService.landingPageData?.digilockerSection.subText2 && landingService.landingPageData?.digilockerSection.subText3){
                        {{landingService.landingPageData?.digilockerSection.subText2}}
                        {{landingService.landingPageData?.digilockerSection.subText3}}
                        {{landingService.landingPageData?.digilockerSection.subText4}}<br/>
                      }@else{
                        Access your government IDs, certificates and marksheets digitally on your phone, whenever and wherever you need them.<br/>
                      }
                    </p>
                  }@else{
                    <p>
                      @if(landingService.landingPageData?.digilockerSection.subText2 && landingService.landingPageData?.digilockerSection.subText3){
                        {{landingService.landingPageData?.digilockerSection.subText2}}<br/> 
                        {{landingService.landingPageData?.digilockerSection.subText3}}<br/>
                        {{landingService.landingPageData?.digilockerSection.subText4}}<br/>
                      }@else{
                        Access your government IDs, certificates and <br/> marksheets digitally on your phone, whenever and <br/> wherever you need them.<br/>
                      }
                    </p>
                  }
                </div>
              </div>
            </section>
          }
          
        </div>
        
        @defer{
          <section id="download-qrcode-jiocloud">
            <h2 class="section-title-large text-center">
              @if(landingService.landingPageData?.downloadJioCloud.bigTitle){
                {{landingService.landingPageData?.downloadJioCloud.bigTitle}}
              }@else{
                Download JioAICloud
              }
            </h2>
            <div class="text-center digilocker-cont">
              <div class="qrcode-details">
                @if(!universalService.isMobileDevice){
                  @defer{
                    <img loading="lazy" src="https://static.jiocloud.com/web2.0/landing/Images/landing-qr-code.webp" alt="qrcode" >
                  }
                  <p>
                    @if(landingService.landingPageData?.downloadJioCloud.txt3){
                      {{landingService.landingPageData?.downloadJioCloud.txt3}}
                    }@else{
                      Scan to download
                    }
                  </p>
                }@else{
                  @if(this.universalService.browserDetails.os.name == "Android"){
                    @defer{
                      <img loading="lazy" src="https://static.jiocloud.com/web2.0/landing/Images/google-play.webp" alt="app-store"  (click)="openDownloadLink('playstore')">
                    }
                  }@else if(this.universalService.browserDetails.os.name == "iOS"){
                    @defer{
                      <img loading="lazy" src="https://static.jiocloud.com/web2.0/landing/Images/app-store.webp" alt="play-store" (click)="openDownloadLink('appstore')">
                    }
                  }
                }

              </div>
              <p class="made-in-india-txt">
                @if(universalService.isMobileDevice){
                  @if(landingService.landingPageData?.downloadJioCloud.txt1 && landingService.landingPageData?.downloadJioCloud.txt2){
                    {{landingService.landingPageData?.downloadJioCloud.txt1}}<br/>{{landingService.landingPageData?.downloadJioCloud.txt2}}
                  }@else{
                    Proudly made in India,<br/> securely stored in India.
                  }
                }@else{
                  @if(landingService.landingPageData?.downloadJioCloud.txt1 && landingService.landingPageData?.downloadJioCloud.txt2){
                    {{landingService.landingPageData?.downloadJioCloud.txt1}}{{landingService.landingPageData?.downloadJioCloud.txt2}}
                  }@else{
                    Proudly made in India, securely stored in India.
                  }
                }
              </p>
            </div>
          </section>
        }

        <!-- <section id="support">
          <h2 class="section-title-large text-center">Need support?</h2>
          <p class="text-center">We'd love to help tou.</p>
          <div class="text-center support-cont">
            <div class="support-details">
              <div>
                <img src="https://static.jiocloud.com/web2.0/landing/images/support-icon1.svg" />
                Support
              </div>
              <div>
                <img src="https://static.jiocloud.com/web2.0/landing/images/support-icon2.svg" />
                Chat with us
              </div>
              <div>
                <img src="https://static.jiocloud.com/web2.0/landing/images/support-icon3.svg" />
                Call us
              </div>
            </div>
          </div>
        </section> -->
      </div>


    </section>
    @if(universalService.isMobileDevice){
      <section id="user-login" class="user-login-mobile">
        <div class="user-login-block">
          <div class="area-code-mobile">+91</div>
          <input  #jionumber type="text" placeholder="Mobile Number" maxlength="10" (keyup)="loginNoValidation(jionumber)" id="jioPhoneNumber" autocomplete="off"/>
          <button (click)="openLogin(jionumber)">
            @if(landingService.landingPageData?.login?.txt1){
              {{landingService.landingPageData?.login?.txt1}}
            }@else{
              Sign in
            }
          </button>
        </div>
      </section>
    }
    @defer{
    <lib-landing-footer/>
    }
    @defer{
      <div class="landscapeNone">
        <div class="user-message">
          <img loading="lazy" src="https://static.jiocloud.com/web2.0/landing/Images/rotate-portrait.svg" alt="rotate-portrait.svg" class="icon-rotate">
          <p>Rotate your device to portrait mode for a better viewing experience of JioAICloud.</p>
          @if(!universalService.isMobileDevice) {
            <p style="font-size: 11px;">Reset the zoom level to 100% by using command Ctrl + 0 (Windows) or Command + 0 (Mac).</p>
          }
        </div>
      </div>
    }
  </div>
</main>